import {
  GET_KPI_DELIVERED_BY_DRIVER,
  GET_KPI_DELIVERED_BY_MONTH, GET_KPI_DELIVERED_BY_PROVINCE, GET_KPI_DELIVERED_BY_WEEKLY, GET_KPI_DELIVERED_FAILED,
  GET_KPI_STATISTIC,
  GetRequest,
  GetResultObject
} from "../../../utils/API";
import {GET_KPI_DELIVERED_BY_YEAR, GET_KPI_DRIVER_BY_DRIVER} from "../../../utils/Endpoints";
import _ from 'lodash';

const TYPES = {
  REQUEST_STATISTIC: "REQUEST_STATISTIC",
  REQUEST_STATISTIC_SUCCESS: "REQUEST_STATISTIC_SUCCESS",

  REQUEST_KPI_DELIVERED_BY_DRIVER: "REQUEST_KPI_DELIVERED_BY_DRIVER",
  REQUEST_KPI_DELIVERED_BY_DRIVER_SUCCESS: "REQUEST_KPI_DELIVERED_BY_DRIVER_SUCCESS",
  REQUEST_KPI_DELIVERED_BY_DRIVER_FAILED: "REQUEST_KPI_DELIVERED_BY_DRIVER_FAILED",

  REQUEST_KPI_DELIVERED_BY_MONTH: "REQUEST_KPI_DELIVERED_BY_MONTH",
  REQUEST_KPI_DELIVERED_BY_MONTH_SUCCESS: "REQUEST_KPI_DELIVERED_BY_MONTH_SUCCESS",
  REQUEST_KPI_DELIVERED_BY_MONTH_FAILED: "REQUEST_KPI_DELIVERED_BY_MONTH_FAILED",

  REQUEST_KPI_DELIVERED_BY_WEEKLY: "REQUEST_KPI_DELIVERED_BY_WEEKLY",
  REQUEST_KPI_DELIVERED_BY_WEEKLY_SUCCESS: "REQUEST_KPI_DELIVERED_BY_WEEKLY_SUCCESS",
  REQUEST_KPI_DELIVERED_BY_WEEKLY_FAILED: "REQUEST_KPI_DELIVERED_BY_WEEKLY_FAILED",

  REQUEST_KPI_DELIVERED_BY_YEAR: "REQUEST_KPI_DELIVERED_BY_YEAR",
  REQUEST_KPI_DELIVERED_BY_YEAR_SUCCESS: "REQUEST_KPI_DELIVERED_BY_YEAR_SUCCESS",
  REQUEST_KPI_DELIVERED_BY_YEAR_FAILED: "REQUEST_KPI_DELIVERED_BY_YEAR_FAILED",

  REQUEST_KPI_DELIVERED_BY_PROVINCE: "REQUEST_KPI_DELIVERED_BY_PROVINCE",
  REQUEST_KPI_DELIVERED_BY_PROVINCE_SUCCESS: "REQUEST_KPI_DELIVERED_BY_PROVINCE_SUCCESS",
  REQUEST_KPI_DELIVERED_BY_PROVINCE_FAILED: "REQUEST_KPI_DELIVERED_BY_PROVINCE_FAILED",

  REQUEST_KPI_DELIVERED_FAILED: "REQUEST_KPI_DELIVERED_FAILED",
  REQUEST_KPI_DELIVERED_FAILED_SUCCESS: "REQUEST_KPI_DELIVERED_FAILED_SUCCESS",
  REQUEST_KPI_DELIVERED_FAILED_FAILED: "REQUEST_KPI_DELIVERED_FAILED_FAILED",

  REQUEST_KPI_DELIVERED_FAILED_BY_DRIVER: "REQUEST_KPI_DELIVERED_FAILED_BY_DRIVER",
  REQUEST_KPI_DELIVERED_FAILED_BY_DRIVER_SUCCESS: "REQUEST_KPI_DELIVERED_FAILED_BY_DRIVER_SUCCESS",
  REQUEST_KPI_DELIVERED_FAILED_BY_DRIVER_FAILED: "REQUEST_KPI_DELIVERED_FAILED_BY_DRIVER_FAILED",
};


const getStatistic = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_STATISTIC,
      payload: {},
    });

    GetRequest(GET_KPI_STATISTIC, params).then(result=> {
      GetResultObject(result, 'data', 200, (datas) => {
        const list = datas.filter(item => {
          if(_.get(item, 'currentStatus') != 'Deleted') return item
        })
        dispatch({
          type: TYPES.REQUEST_STATISTIC_SUCCESS,
          payload: list,
        });
      })
    })

  }
}

const getKpiDeliveredByDriver = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_KPI_DELIVERED_BY_DRIVER,
      payload: {},
    });

    GetRequest(GET_KPI_DELIVERED_BY_DRIVER, params).then((result) => {
      GetResultObject(result, 'data', 200, datas => {
        dispatch({
          type: TYPES.REQUEST_KPI_DELIVERED_BY_DRIVER_SUCCESS,
          payload: datas,
        });
      })
    }).catch((error) => {
      dispatch({
        type: TYPES.REQUEST_KPI_DELIVERED_BY_DRIVER_FAILED,
        payload: {error},
      });
    });
  }
};

const getKpiDeliveredByMoth = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_KPI_DELIVERED_BY_MONTH,
      payload: {},
    });

    GetRequest(GET_KPI_DELIVERED_BY_MONTH, params).then((result) => {
      GetResultObject(result, 'data', 200, datas => {
        dispatch({
          type: TYPES.REQUEST_KPI_DELIVERED_BY_MONTH_SUCCESS,
          payload: datas,
        });
      })
    }).catch((error) => {
      dispatch({
        type: TYPES.REQUEST_KPI_DELIVERED_BY_MONTH_FAILED,
        payload: {error},
      });
    });
  }
};

const getKpiDeliveredByWeekly = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_KPI_DELIVERED_BY_WEEKLY,
      payload: {},
    });

    GetRequest(GET_KPI_DELIVERED_BY_WEEKLY, params).then((result) => {
      GetResultObject(result, 'data', 200, datas => {
        dispatch({
          type: TYPES.REQUEST_KPI_DELIVERED_BY_WEEKLY_SUCCESS,
          payload: datas,
        });
      })
    }).catch((error) => {
      dispatch({
        type: TYPES.REQUEST_KPI_DELIVERED_BY_WEEKLY_FAILED,
        payload: {error},
      });
    });
  }
};

const getKpiDeliveredByYear = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_KPI_DELIVERED_BY_YEAR,
      payload: {},
    });

    GetRequest(GET_KPI_DELIVERED_BY_YEAR, params).then((result) => {
      GetResultObject(result, 'data', 200, datas => {
        dispatch({
          type: TYPES.REQUEST_KPI_DELIVERED_BY_YEAR_SUCCESS,
          payload: datas,
        });
      })
    }).catch((error) => {
      dispatch({
        type: TYPES.REQUEST_KPI_DELIVERED_BY_YEAR_FAILED,
        payload: {error},
      });
    });
  }
};

const getKpiDeliveredByProvince = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_KPI_DELIVERED_BY_PROVINCE,
      payload: {},
    });

    GetRequest(GET_KPI_DELIVERED_BY_PROVINCE, params).then((result) => {
      GetResultObject(result, 'data', 200, datas => {
        dispatch({
          type: TYPES.REQUEST_KPI_DELIVERED_BY_PROVINCE_SUCCESS,
          payload: datas,
        });
      })
    }).catch((error) => {
      dispatch({
        type: TYPES.REQUEST_KPI_DELIVERED_BY_PROVINCE_FAILED,
        payload: {error},
      });
    });
  }
};

const getKpiDeliveredFailed = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_KPI_DELIVERED_FAILED,
      payload: {},
    });

    GetRequest(GET_KPI_DELIVERED_FAILED, params).then((result) => {
      GetResultObject(result, 'data', 200, datas => {
        dispatch({
          type: TYPES.REQUEST_KPI_DELIVERED_FAILED_SUCCESS,
          payload: datas,
        });
      })
    }).catch((error) => {
      dispatch({
        type: TYPES.REQUEST_KPI_DELIVERED_FAILED_FAILED,
        payload: {error},
      });
    });
  }
};

const getKpiDeliveredFailedByDriver = (params) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_KPI_DELIVERED_FAILED_BY_DRIVER,
      payload: {},
    });

    GetRequest(GET_KPI_DRIVER_BY_DRIVER, params).then((result) => {
      GetResultObject(result, 'data', 200, datas => {
        dispatch({
          type: TYPES.REQUEST_KPI_DELIVERED_FAILED_BY_DRIVER_SUCCESS,
          payload: datas,
        });
      })
    }).catch((error) => {
      dispatch({
        type: TYPES.REQUEST_KPI_DELIVERED_FAILED_BY_DRIVER_FAILED,
        payload: {error},
      });
    });
  }
};


export default {
  getKpiDeliveredByDriver,
  getKpiDeliveredByMoth,
  getKpiDeliveredByWeekly,
  getKpiDeliveredByYear,
  getKpiDeliveredByProvince,
  getKpiDeliveredFailed,
  getKpiDeliveredFailedByDriver,
  getStatistic,
  TYPES,
};
